<template>
  <div id="timing" class="modal">
    <div class="modal-content animate">
      <div class="col-lg-12 card">
        <div class="card-header">
          <div class="category">{{'Danh sách cổng của node ' + nodeIndex}} </div>
          <span onclick="document.getElementById('timing').style.display='none';" class="close" title="Close Modal">&times;</span>
        </div>
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm"
                        placeholder="Search"
                        v-model="searchQuery"
                        addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                      :data="queriedData"
                      border
                      style="width: 100%">
              <el-table-column
                key="Cổng điều khiển"
                min-width="50"
                prop="port"
                label="Cổng điều khiển">
                <template slot-scope="props">
                  <template v-if="props.row.active">
                    <span>{{props.row.port}} </span>
                    <span style="float:right">ON </span>
                  </template>
                  
                  <template v-else>
                    <span style="margin-left:10%">{{props.row.port}} </span>
                    <span style="float:right;margin-right:10%">OFF </span>
                  </template>
                  
                </template>
              </el-table-column>
              <el-table-column
                key="Khu vực"
                min-width="40"
                prop="region"
                label="Khu vực">
              </el-table-column>
              <el-table-column
                key="Hẹn giờ 1"
                min-width="90"
                label="Hẹn giờ 1">
                <template slot-scope="props">
                  <span>
                    <el-time-select
                      style="width:40%"
                      v-model="props.row.timeon1"
                      :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                      }">
                    </el-time-select>
                    <span> đến </span>
                    <el-time-select
                      style="width:40%"
                      v-model="props.row.timeoff1"
                      :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                      }">
                    </el-time-select>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                key="Hẹn giờ 2"
                min-width="90"
                label="Hẹn giờ 2">
                <template slot-scope="props">
                  <span>
                    <el-time-select
                      style="width:40%"
                      v-model="props.row.timeon2"
                      :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                      }">
                    </el-time-select>
                    <span> đến </span>
                    <el-time-select
                      style="width:40%"
                      v-model="props.row.timeoff2"
                      :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                      }">
                    </el-time-select>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="35"
                label="Gửi lệnh">
                <template slot-scope="props">
                  <p-button title="Gửi lệnh hẹn giờ" class="centered"  type="success" size="sm" icon @click="sendData(props.$index, props.row)">
                    <i class="nc-icon nc-cloud-upload-94"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Hiển thị {{from + 1}} tới {{to}} trong {{total}} cổng</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Card } from 'src/components/UIComponents';
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {Table, TimeSelect, TableColumn, Select, Option, InputNumber} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import {Button} from 'src/components/UIComponents'

  import axios from "axios";
  import VueAxios from "vue-axios";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      Card,
      PSwitch,
      PPagination,
      [Button.name]: Button,
      [TimeSelect.name]: TimeSelect
    },
    props:{
      nodeIndex: Number,
      tableData: {
            port: Number,
            timeon1: {
              type: String,
              default: '',
            },
            timeoff1: {
              type: String,
              default: '',
            },
            timeon2: {
              type: String,
              default: '',
            },
            timeoff2: {
              type: String,
              default: '',
            },            
            region: String,            
            active: Boolean,
            houron1: String,
            minon1: String,
            houroff1: String,
            minoff1: String,
            houron2: String,
            minon2: String,
            houroff2: String,
            minoff2: String,
        },
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /**

       * 
array.
       * 
ot of data as it might be slow!
       * 
isplay the data retrieved from server instead.
       * 

       */

      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        pagination: {

          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['region', 'port'],
      }
    },
    methods: {
      sendData (index, row) {                                    
        let token = localStorage.getItem('token');        // Token got from login
        let data = {
          tokenkey: token,
          id: this.nodeIndex,
          numPump: row.port,
          hour_on1: '99',
          minute_on1: '99',
          hour_off1: '99',
          minute_off1: '99',
          hour_on2: '99',
          minute_on2: '99',
          hour_off2: '99',
          minute_off2: '99',          
        }
        if (row.timeon1 && row.timeoff1) {
          data.hour_on1 = row.timeon1.substring(0,2);
          data.minute_on1 = row.timeon1.substring(3,5);
          data.hour_off1 = row.timeoff1.substring(0,2);
          data.minute_off1 = row.timeoff1.substring(3,5);
          if (data.hour_on1 > data.hour_off1 || (data.hour_on1 == data.hour_off1 && data.minute_on1 > data.minute_off1)) {
            alert('Giờ tắt phải sau giờ bật')
            return
          }
        } else if (row.timeon1 || row.timeoff1) {
          alert('Phải nhập cả giờ tắt và bật 1')
          return
        }

        if (row.timeon2 && row.timeoff2) {
          data.hour_on2 = row.timeon2.substring(0,2);
          data.minute_on2 = row.timeon2.substring(3,5);
          data.hour_off2 = row.timeoff2.substring(0,2);
          data.minute_off2 = row.timeoff2.substring(3,5);
          if (data.hour_on2 > data.hour_off2 || (data.hour_on2 == data.hour_off2 && data.minute_on2 > data.minute_off2)) {
            alert('Giờ tắt phải sau giờ bật')
            return
          }
        } else if (row.timeon2 || row.timeoff2) {
          alert('Phải nhập cả giờ tắt và bật 2')
          return
        }
          axios({url: '/LoraNode/LoraSetAlarm', 
                data: data, 
                method: 'POST' })
          .then(function(res){
            alert('Đã gửi cấu hình hẹn giờ')
            return(res)
          })
          .catch(function(err){
            alert("Hẹn giờ thất bại")
            return(err)
          })

        document.getElementById('node_control').style.display = 'none';
      }      
    },
    async mounted() {
      
    }
  }
</script>
<style scoped>
.modal{
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 900px;
    height: 100%;
    min-height: 60px;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    padding-top: 60px;
}
  
.modal-content {
    background-color: #fefefe;
    margin: 3% 2% 0% auto; /* 0% from the top, 15% from the bottom and centered */
    border: 1px solid #888;
    width: 75%; /* Could be more or less, depending on screen size */
    height:auto;
    border-radius:5px;
}

.close {
    color: #000;
    font-size: 35px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: red;
    cursor: pointer;
}

/* Add Zoom Animation */
.animate {
    -webkit-animation: animatezoom 0.6s;
    animation: animatezoom 0.6s
}

.modal .el-table table tbody tr td{
  padding: 3px 0px;
}

.centered {
  left: 50%;
  transform: translate(-50%, 0%);
}

@-webkit-keyframes animatezoom {
    from {-webkit-transform: scale(0)} 
    to {-webkit-transform: scale(1)}
}
  
@keyframes animatezoom {
    from {transform: scale(0)} 
    to {transform: scale(1)}
}
</style>
-